import { render, staticRenderFns } from "./maintain-order-detail-modal.vue?vue&type=template&id=0b46ced4"
import script from "./maintain-order-detail-modal.vue?vue&type=script&lang=js"
export * from "./maintain-order-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports